import React from "react";
import { Path } from "paths";
import {
  InventoryReport,
  CategoryReport,
  DiscountReport,
  VoucherReport,
  SalesReport,
  AdditionalChargeReport,
  TipReport,
  FreeCreditsReport,
  OngroundReport,
  DuplicateTicketsReport,
  GuestRefundsReport,
  RefundClaimsReport,
  UnSyncTransactionReport,
  MonthlySaleReport,
  ArrivalTimeReport
} from "modules";
import { RouteRender } from "components/commons";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useMount } from "hooks";
import { setPageTitle } from "services";
import AccessControlReport from "modules/report/access-control";

const ReportPage = () => {
  const flags = useFlags();
  const { inventoryReport, categoryReport, discountReport, voucherReport } = flags;

  useMount(() => {
    setPageTitle("reports");
  });

  return (
    <RouteRender
      defaultRedirect={Path.REPORT_SALES}
      renders={{
        [Path.REPORT_SALES]: {
          exact: true,
          component: SalesReport,
        },
        [Path.REPORT_INVENTORY]: {
          exact: true,
          component: InventoryReport,
          featureFlag: inventoryReport,
        },
        [Path.REPORT_CATEGORY]: {
          exact: true,
          component: CategoryReport,
          featureFlag: categoryReport,
        },
        [Path.REPORT_DISCOUNT]: {
          exact: true,
          component: DiscountReport,
          featureFlag: discountReport,
        },
        [Path.REPORT_VOUCHER]: {
          exact: true,
          component: VoucherReport,
          featureFlag: voucherReport,
        },
        [Path.REPORT_ADDITIONAL_CHARGE]: {
          exact: true,
          component: AdditionalChargeReport,
        },
        [Path.REPORT_TIP]: {
          exact: true,
          component: TipReport,
        },
        [Path.REPORT_FREE_CREDITS]: {
          exact: true,
          component: FreeCreditsReport,
        },
        [Path.REPORT_ACCESS_CONTROL]: {
          exact: true,
          component: AccessControlReport,
        },
        [Path.REPORT_ARRIVAL_TIME]: {
          exact: true,
          component: ArrivalTimeReport,
        },
        [Path.REPORT_ON_GROUND]: {
          exact: true,
          component: OngroundReport,
        },
        [Path.REPORT_DUPLICATE_TICKETS]: {
          exact: true,
          component: DuplicateTicketsReport,
        },
        [Path.REPORT_GUEST_REFUND]: {
          exact: true,
          component: GuestRefundsReport,
        },
        [Path.REPORT_REFUND_CLAIM]: {
          exact: true,
          component: RefundClaimsReport,
        },
         [Path.UNSYNC_TRANSACTION]: {
          exact: true,
          component: UnSyncTransactionReport,
        }        ,
        [Path.MONTHLY_SALE_REPORT]: {
          exact: true,
          component: MonthlySaleReport,
        }
      }}
    />
  );
};

export default ReportPage;
